import type { EntityDetailMetadata } from '@zag/ui';

const SETTINGS_UPDATE = { mode: 'all', permissions: ['settings:update'] } as const;

export const AUTH_ENTITY_DETAIL_METADATA = [
  {
    entity: 'user',
    route: '/settings/users/:id',
    titleKey: 'settings.users.title',
    sections: [
      { id: 'link-person', titleKey: 'settings.users.quickActions.linkPerson' },
      { id: 'inherited-roles', titleKey: 'settings.users.sections.inheritedRoles', requiresEntityId: true },
      { id: 'effective-permissions', titleKey: 'settings.users.sections.effectivePermissions', requiresEntityId: true },
      { id: 'direct-roles', titleKey: 'settings.users.sections.directRoles', requiresEntityId: true },
      { id: 'groups', titleKey: 'settings.users.sections.groups', requiresEntityId: true },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: SETTINGS_UPDATE, intent: 'mutation' },
      { id: 'delete', labelKey: 'settings.users.deleteUser', visibleWhen: SETTINGS_UPDATE, requiresEntityId: true, intent: 'mutation' },
      {
        id: 'send-password-reset',
        labelKey: 'settings.users.actions.sendPasswordReset',
        visibleWhen: { mode: 'all', permissions: ['rbac:users:update'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'invitation',
    route: '/settings/users/invitation/:id',
    titleKey: 'settings.users.invite.title',
    sections: [
      { id: 'details', titleKey: 'settings.users.invite.details' },
      { id: 'general', titleKey: 'settings.users.invite.details' },
      { id: 'direct-roles', titleKey: 'settings.users.sections.directRoles' },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: SETTINGS_UPDATE, intent: 'mutation' },
      { id: 'resend', labelKey: 'settings.users.actions.resend', visibleWhen: SETTINGS_UPDATE, requiresEntityId: true, intent: 'mutation' },
      {
        id: 'revoke',
        labelKey: 'settings.users.invite.revoke.button',
        visibleWhen: SETTINGS_UPDATE,
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'group',
    route: '/settings/groups/:id',
    titleKey: 'settings.groups.title',
    sections: [
      { id: 'details', titleKey: 'settings.groups.sections.details' },
      { id: 'members', titleKey: 'settings.groups.tabMembers', requiresEntityId: true },
      { id: 'roles', titleKey: 'settings.groups.tabRoles', requiresEntityId: true },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: SETTINGS_UPDATE, intent: 'mutation' },
      { id: 'delete', labelKey: 'common.delete', visibleWhen: SETTINGS_UPDATE, requiresEntityId: true, intent: 'mutation' },
    ],
  },
  {
    entity: 'role',
    route: '/settings/roles/:id',
    titleKey: 'settings.roles.title',
    sections: [
      { id: 'details', titleKey: 'settings.roles.sections.details' },
      { id: 'permissions', titleKey: 'settings.roles.permissions', requiresEntityId: true },
      { id: 'users', titleKey: 'settings.roles.users.title', requiresEntityId: true },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: SETTINGS_UPDATE, intent: 'mutation' },
      { id: 'delete', labelKey: 'common.delete', visibleWhen: SETTINGS_UPDATE, requiresEntityId: true, intent: 'mutation' },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
